import { FC, useContext } from "react";
import { Col, Row } from "../../grid";
import { ProgressBar } from "../../progress/ProgressBar";
import { Text } from "../../typography/Text";
import { AppContext } from "../../../pages/profile/Profile";
import styles from "./SkillsList.module.scss";

export type SkillEntryType = {
  name: string;
  since: number;
};

export const SkillsList: FC<{ list: SkillEntryType[] }> = ({ list }) => {
  const { keys } = useContext(AppContext);

  const currentYear = new Date().getFullYear();
  const experienceStartRaw = keys?.["experienceStartYear"];
  const experienceStartYear = experienceStartRaw
    ? new Date(experienceStartRaw).getFullYear()
    : currentYear;
  const experienceTotalYears = Math.max(1, currentYear - experienceStartYear);

  return (
    <div className={styles.skills}>
      <Row gutter={["large", "large"]}>
        {list.map((entry) => (
          <Col md={12} key={entry.name}>
            <ProgressBar
              percent={
                Math.round(((currentYear - entry.since) / experienceTotalYears) * 100)
              }
            >
              <Text>{entry.name}</Text>&nbsp;&nbsp;
              <Text opacity={50}>
                ({currentYear - entry.since} years)
              </Text>
            </ProgressBar>
          </Col>
        ))}
      </Row>
    </div>
  );
};
